import jwtDecode from 'jwt-decode';
import axios from 'Axios';
import { POST_LOGIN_USER, POST_REFRESH_TOKEN } from '../api/Routes';

export const LOGIN_ERROR = '@login/ERROR';
export const LOGIN_START = '@login/REQ';
export const LOGIN_RESET_ERROR = '@login/RESET_ERROR';
export const LOAD_ACCOUNT = '@login/LOAD_ACCOUNT';
export const LOGOUT_USER = '@login/LOGOUT_USER';

const loadAccount = token => {
  const role = getRole(token);
  return {
    type: LOAD_ACCOUNT,
    role,
  };
};

const getRole = token => {
  let decodedToken = jwtDecode(token);
  if (decodedToken) {
    return decodedToken.authorities;
  }
  return '';
};

export const onUserLogout = () => dispatch => {
  axios
    .post('logout', null)
    .then(response => {
      sessionStorage.setItem('isUserLoggedIn', false);
      axios.defaults.headers.common['Authorization'] = ``;
      dispatch({ type: LOGOUT_USER });
    })
    .catch(err => {
      sessionStorage.setItem('isUserLoggedIn', false);
      axios.defaults.headers.common['Authorization'] = ``;
      dispatch({ type: LOGOUT_USER });
    });
};

export const checkToken = () => async dispatch => {
  if (sessionStorage.getItem('isUserLoggedIn') === 'true') {
    try {
      const response = await axios.post(POST_REFRESH_TOKEN, null);
      const token = response.data.token;
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      dispatch(loadAccount(token));
    } catch (err) {
      dispatch({ type: LOGOUT_USER });
    }
  } else {
    dispatch({ type: LOGOUT_USER });
  }
};

export const onLoginError = error => {
  return {
    type: LOGIN_ERROR,
    error,
  };
};

export const onErrorReset = () => {
  return {
    type: LOGIN_RESET_ERROR,
  };
};

// TODO: refactor
export const loginUser = (username, password, setSubmitting) => {
  return function(dispatch) {
    dispatch({ type: LOGIN_START });
    axios
      .post(POST_LOGIN_USER, {
        username,
        password,
      })
      .then(response => {
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        sessionStorage.setItem('isUserLoggedIn', true);
        dispatch(loadAccount(data.token));
      })
      .catch(error => {
        setSubmitting(false);
        // Error
        dispatch(onLoginError(error));
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
      });
  };
};
